module.exports = __webpack_public_path__ + "img/zaoni.a241c2e7.jpg";